<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="商品名称" :value="1"></el-option>
                            <el-option label="商品ID" :value="2"></el-option>
                            <el-option label="订单编号" :value="3"></el-option>
                            <el-option label="收货手机号" :value="4"></el-option>
                            <el-option label="下单用户ID" :value="5"></el-option>
                            <el-option label="结款方ID" :value="6"></el-option>
                            <el-option label="发货方ID" :value="7"></el-option>
                            <el-option label="运单号" :value="8"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.paymentStatus" placeholder="请选择" size="small">
                        <el-option label="不限制支付状态" value=""></el-option>
                        <el-option label="仅看未支付的" :value="1"></el-option>
                        <el-option label="仅看已支付的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.orderStatus" placeholder="请选择" size="small">
                        <el-option label="不限制订单状态" value=""></el-option>
                        <el-option label="仅看待支付的" :value="1"></el-option>
                        <el-option label="仅看待发货的" :value="2"></el-option>
                        <el-option label="仅看部分发货的" :value="3"></el-option>
                        <el-option label="仅看全部发货的" :value="4"></el-option>
                        <el-option label="仅看已完成的" :value="5"></el-option>
                        <el-option label="仅看已过期的" :value="6"></el-option>
                        <el-option label="仅看已取消的" :value="7"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.categoryId" placeholder="请选择类别" size="small">
                        <el-option label="所有类别" value=""></el-option>
                        <template v-for="(item,index) in category">
                            <el-option :key="index" :label="'仅看' + item.label" :value="item.value"></el-option>
                        </template>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.deliveryType" placeholder="请选择" size="small">
                        <el-option label="不限制发货类型" value=""></el-option>
                        <el-option label="仅看快递发货的" :value="1"></el-option>
                        <el-option label="仅看现场自取的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="不限制商品使用场景" value=""></el-option>
                        <el-option label="仅看C端自用的" :value="1"></el-option>
                        <el-option label="仅看直播送礼的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.afterSalesStatus" placeholder="请选择" size="small">
                        <el-option label="不限制售后状态" :value="0"></el-option>
                        <el-option label="仅看待退款的" :value="3"></el-option>
                        <el-option label="仅看已退款的" :value="4"></el-option>
						<el-option label="仅看退款失败的" :value="9"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="下单时间" :value="1"></el-option>
                                <el-option label="发货时间" :value="5"></el-option>
                                <el-option label="退款时间" :value="2"></el-option>
                                <el-option label="支付时间" :value="3"></el-option>
                                <el-option label="取消时间" :value="4"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.balanceType" placeholder="请选择" size="small">
				        <el-option label="不限制结算方式" value=""></el-option>
				        <el-option label="仅看自营-预付款的" :value="1"></el-option>
				        <el-option label="仅看代销-后付款的" :value="2"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/goodOrder/createExport')" type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出订单</el-button>
            <el-button v-if="$utils.have('/goodOrder/batchImport')"  type="primary" icon="el-icon-set-up" size="small" @click="$refs.batchImport.show()">批量操作</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="sn" label="订单编号" min-width="140"></el-table-column>
                <el-table-column prop="shopGoodIds" label="商品ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shopGoodNames" label="商品名称" show-overflow-tooltip min-width="250">
                </el-table-column>
                <el-table-column prop="goodsNum" label="商品总数"></el-table-column>
                <el-table-column prop="orderStatus" label="订单状态">
                    <template slot-scope="scope">
                       {{orderStatus.get(scope.row.orderStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="deliveryTypeStr" label="发货类型"></el-table-column>
                <el-table-column prop="telephone" label="收货手机号" min-width="130"></el-table-column>
                <el-table-column prop="freightStr" label="运费"></el-table-column>
                <el-table-column prop="realPayAmountStr" label="实际支付金额" min-width="100"></el-table-column>
                <el-table-column prop="pendingRefundNum" label="待退款数量" min-width="90"></el-table-column>
                <el-table-column prop="refundedCount" label="已退款数量" min-width="90"></el-table-column>
                <el-table-column prop="payTime" label="支付时间" min-width="150"></el-table-column>
                <el-table-column prop="cancelTime" label="取消时间" min-width="150"></el-table-column>
                <el-table-column prop="expressTime" label="最晚发货时间" min-width="150"></el-table-column>
				<el-table-column prop="categoryNames" label="商品类别" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="230">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/goodOrder/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="edit(scope.row.id)"
                            >详情</el-button>
                        <el-button
                            v-if="scope.row.deliveryTypeStr == '自取' && scope.row.isSign == 0 "
                            type="text"
                            size="small"
                            icon="el-icon-position"
                            @click="qianshou(scope.row.id)"
                            >签收{{scope.row.deliveryType}}</el-button>
                        <template v-if="$utils.have('/goodOrder/singleDeliverGoods') && scope.row.deliveryTypeStr == '寄送'">
                            <el-button
                                v-if="scope.row.orderStatus == 2 || scope.row.orderStatus == 3"
                                type="text"
                                size="small"
                                icon="el-icon-position"
                                @click="$refs.updateDeliverInfo.show(scope.row)"
                                >发货</el-button>
                            <el-button
                                v-if="scope.row.orderStatus == 4 || scope.row.orderStatus == 5"
                                type="text"
                                size="small"
                                icon="el-icon-position"
                                @click="$refs.updateDeliverInfo.show(scope.row)"
                                >更新发货</el-button>
                        </template>
                        
                        <el-button
                            v-if="$utils.have('/goodOrder/refund') && scope.row.orderStatus != 1 && scope.row.orderStatus != 6"
                            type="text"
                            size="small"
                            icon="el-icon-money"
                            @click="$refs.orderRefund.show(scope.row.id)"
                            >退款</el-button>
                        <el-button
                            v-if="scope.row.orderStatus == 1 && $utils.have('/goodOrder/cancel')"
                            type="text"
                            size="small"
                            icon="el-icon-remove-outline"
                            @click="cancel(scope.row.id)"
                            >取消</el-button>
                    </template>    
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <UpdateDeliverInfo ref="updateDeliverInfo" @onUpdate="getDataList"></UpdateDeliverInfo>
        <BatchImport ref="batchImport" @onUpdate="getDataList"></BatchImport>
        <OrderRefund ref="orderRefund" @onUpdate="getDataList"></OrderRefund>
    </div>
</template>

<script>
import UpdateDeliverInfo from './components/updateDeliverInfo';
import BatchImport from './components/batchImport';
import OrderRefund from './components/orderRefund';
const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
    dateType: 1,
    startTime: '',
    endTime: '',
    categoryId: '',
    type: '',
    paymentStatus: '',
    orderStatus: 2,
    afterSalesStatus: 0,
    deliveryType: '',
	balanceType:''
}
export default {
    components:{UpdateDeliverInfo,BatchImport,OrderRefund},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                dateType: parseInt(this.$route.query.dateType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
                categoryId: this.$route.query.categoryId ? parseInt(this.$route.query.categoryId) : '',
                type: this.$route.query.type ? parseInt(this.$route.query.type) : '',
                paymentStatus: this.$route.query.paymentStatus ? parseInt(this.$route.query.paymentStatus) : '',
                orderStatus: this.$route.query.orderStatus ? parseInt(this.$route.query.orderStatus) : 2,
                afterSalesStatus: this.$route.query.afterSalesStatus ? parseInt(this.$route.query.afterSalesStatus) : 0,
                deliveryType: this.$route.query.deliveryType ? parseInt(this.$route.query.deliveryType) : '',
            },
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            listLoading: true,
            downLoading: false
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'全部发货'],
                [5,'已完成'],
                [6,'已过期'],
                [7,'已取消'],
            ])
        },
		category(){
		    return [
		        {value:1,label:'唱片专辑'},
		        {value:2,label:'服饰'},
		        {value:3,label:'纪念品'},
		        {value:5,label:'配饰'},
		        // {value:6,label:'照片'},
		        {value:7,label:'数藏'},
		        {value:4,label:'其它'},
				{value:8,label:'积分商品'},
				{value:9,label:'实体纪念票'},
		    ]
		},
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/goodOrder/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        console.log(this.dataList)
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出订单
        download(){
            this.downLoading = true;
            this.$request({
                url: "/goodOrder/createExport",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
        //编辑事件
        edit(id){
            this.$router.push({
                path: `/goodsManage/order/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //取消订单
        cancel(id){
            this.$confirm('确定要取消吗?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/goodOrder/cancel',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '操作失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => {});
        },
        //自取订单签收
        qianshou(id){
            this.$confirm('是否确定签收?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/goodOrder/sign',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '操作失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => {});
        },
    }
}
</script>